import React from 'react';

const UsersTab = ({
  activeTab,
  handleDeleteUser,
  handleEditUser,
  handleResendSetupEmail,
  setShowCreateUser,
  users
}) => {
  return (
    <>
{activeTab === 'users' && (
              <div className="space-y-6">
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-2xl font-bold text-slate-800">Benutzer verwalten</h2>
                    <p className="text-slate-600 mt-1">Verwalten Sie alle Benutzer des Systems</p>
                  </div>
                  <button
                    onClick={() => setShowCreateUser(true)}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-colors shadow-lg hover:shadow-xl"
                  >
                    Neuen Benutzer erstellen
                  </button>
                </div>

                <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="min-w-full">
                      <thead className="bg-slate-50">
                        <tr>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">Name</th>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">E-Mail</th>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">Rolle</th>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">Passwort</th>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">Token-Status</th>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">Erstellt</th>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">Status</th>
                          <th className="text-left py-4 px-6 font-semibold text-slate-700">Aktionen</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-200">
                        {users.map((user) => (
                          <tr key={user.id} className="hover:bg-slate-50 transition-colors">
                            <td className="py-4 px-6 text-slate-900 font-medium">{user.name}</td>
                            <td className="py-4 px-6 text-slate-700">{user.email}</td>
                            <td className="py-4 px-6">
                              <span className="text-sm bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-medium capitalize">
                                {user.role}
                              </span>
                            </td>
                            <td className="py-4 px-6">
                              {user.password_created ? (
                                <span className="flex items-center text-green-600">
                                  <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                  </svg>
                                  Erstellt
                                </span>
                              ) : (
                                <span className="flex items-center text-orange-600">
                                  <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                  </svg>
                                  Ausstehend
                                </span>
                              )}
                            </td>
                            <td className="py-4 px-6">
                              {!user.password_created && user.token_status && (
                                <div className="flex flex-col">
                                  <span className={`text-xs px-2 py-1 rounded-full font-medium inline-block w-fit ${
                                    user.token_status === 'active' ? 'bg-green-100 text-green-800' :
                                    user.token_status === 'expired' ? 'bg-red-100 text-red-800' :
                                    'bg-gray-100 text-gray-800'
                                  }`}>
                                    {user.token_status === 'active' ? '✓ Aktiv' :
                                     user.token_status === 'expired' ? '⏱ Abgelaufen' :
                                     '✓ Verwendet'}
                                  </span>
                                  {user.token_expires_at && user.token_status === 'active' && (
                                    <span className="text-xs text-slate-500 mt-1">
                                      Läuft ab: {new Date(user.token_expires_at).toLocaleDateString('de-DE', { 
                                        day: '2-digit', 
                                        month: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </span>
                                  )}
                                </div>
                              )}
                              {!user.password_created && !user.token_status && (
                                <span className="text-xs text-slate-400">Kein Token</span>
                              )}
                              {user.password_created && (
                                <span className="text-xs text-slate-400">-</span>
                              )}
                            </td>
                            <td className="py-4 px-6 text-slate-600">
                              {new Date(user.created_at).toLocaleDateString('de-DE')}
                            </td>
                            <td className="py-4 px-6">
                              <span className={`text-sm px-3 py-1 rounded-full font-medium ${
                                user.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                              }`}>
                                {user.is_active ? 'Aktiv' : 'Inaktiv'}
                              </span>
                            </td>
                            <td className="py-4 px-6">
                              <div className="flex items-center space-x-2">
                                {!user.password_created && (
                                  <button
                                    onClick={() => handleResendSetupEmail(user.id, user.email)}
                                    data-testid={`resend-setup-email-btn-${user.id}`}
                                    className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg font-medium transition-colors"
                                    title="Setup-E-Mail erneut senden"
                                  >
                                    📧 E-Mail senden
                                  </button>
                                )}
                                <button
                                  onClick={() => handleEditUser(user)}
                                  className="text-blue-600 hover:text-blue-800 font-medium transition-colors text-sm"
                                >
                                  Bearbeiten
                                </button>
                                <button
                                  onClick={() => handleDeleteUser(user)}
                                  className="text-red-600 hover:text-red-800 font-medium transition-colors text-sm"
                                >
                                  Löschen
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
    </>
  );
};

export default UsersTab;
